<template>
    <v-row>
        <v-col v-for="detail in details.data" :key="detail.id" cols="12">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center" @click="$router.push(`/customers/${detail.user.id}`)">
                    <v-col v-if="detail.user && detail.user.profile">
                        <span>{{detail.user.profile.firstname + ' ' + detail.user.profile.lastname}}</span>
                    </v-col>
                    <v-col v-else>Null</v-col>
                    <v-col>
                        <span>{{ formatMoney(detail.amount) }}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatDate(detail.created) }}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatTime(detail.created) }}</span>
                    </v-col>
                    <v-col>
                        <v-chip v-if="detail.status == 'completed'" dark class="ma-2" color="success">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'pending'" dark class="ma-2" color="orange">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'declined'" dark class="ma-2" color="error">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'processing'" dark class="ma-2" color="blue">
                            {{detail.status}}
                        </v-chip>
                        <v-chip v-if="detail.status == 'refunded'" dark class="ma-2" color="success">
                            {{detail.status}}
                        </v-chip>
                    </v-col>
                    <v-col v-if="detail.status == 'processing' || detail.status == 'completed' ">
                        <span>{{detail.transferReference}}</span>
                    </v-col>
                    <v-col v-if="detail.status == 'pending' " md="2">
                        <v-menu :disabled="!can('can_manage_transactions')" :close-on-content-click="true" bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon>
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item link>
                                    <withdrawalreason-modal color="red" @closeModal = "closeModal" :details="detail" :action="approve"></withdrawalreason-modal>
                                </v-list-item>
                                <v-list-item link>
                                    <withdrawalreason-modal @closeModal = "closeModal" :details="detail" :action="decline"></withdrawalreason-modal>
                                </v-list-item>
                                <v-list-item link>
                                    <withdrawalreason-modal @closeModal = "closeModal" :details="detail" :action="refund"></withdrawalreason-modal>
                                </v-list-item>
                            </v-list>
                        </v-menu> 
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
// ============ IMPORT COMPONENTS ============
import WithdrawalreasonModal from './withdrawal-reason-modal.vue'

// ============== IMPORT SERVICES ============
import {formatMoney} from '@/utils/moneyFormatter';
import { parseTimestamp } from '@/utils/dates'

export default {
    props:{
        details:{
            type : Object
        }
    },
    data: () => ({
        decline : 'decline',
        approve : 'approve',
        refund : 'refund'
    }),
    components:{
        WithdrawalreasonModal
    },
    methods:{
        formatMoney(amount){
            return formatMoney(amount)
        },
        formatDate(date){
            let d = new Date(date)
            let reModelDate = d.toLocaleString(["en-Us"], {
                month: "short",
                day: "2-digit",
                year: "numeric",
            });
            return reModelDate;
        },
        formatTime(date){
            return parseTimestamp(new Date(date), 'HH:mm')
        },
        async closeModal(){
            this.$emit('reload');
        },
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss'

</style>